<template>
	<div class="modal " id="minutes-tag-modal" tabindex="-1" role="dialog" aria-labelledby="myModalOptionLabelTag">
		<div class="modal-dialog modal-dialog-centered tag-modal-size" role="document">
			<div class="modal-content" style="margin-bottom:5rem;">
				<div class="modal-header">
					<h5 class="modal-title" id="myModalOptionLabelTag">タグ編集</h5>
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
				</div>
				<div class="modal-body">
					<form action="#">
						<div class="form-group minutes_tag_parent">
							<select name="minutes_tagname" id="minutes_tagname" size="10" class="form-control" style="width: 80%;"></select>
							<div class="invalid-feedback" name="invalid-feedback">入力してください</div>
						</div>
						<div class="minutes_tagname_list" id="minutes_tagname_list" style="display: none;"></div>
						<div class="minutes_tagname_history tag_history" id="minutes_tagname_history" style="display: none;"></div>
						<input type="text" name="dummytext" class="form-control" style="width: 1px;">
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";
import 'select2';
window.$ = window.jQuery = $;
require('select2/dist/js/i18n/ja');
window.$.fn.select2.defaults.set('language', 'ja');

import 'select2/dist/css/select2.css';

export default {
	props: {
		sendTag: Object,
	},
	data: () => ({
		isFirst: true,
	}),
	
	created() {
		
	},
	
	methods: {
		appendTags($tagarea_check, $text, $taskarearight) {
			
			var $tagid = "";
			if ($tagarea_check.length) {
				$tagid = $tagarea_check.attr("id");
			} else {
				$tagid = "Tag" + this.getObjectID()
			}

			var $textarea = $(".minutes-active").closest("tr").find(".minutes_manager");
			var agenda_detail_id = $textarea.attr("agenda_detail_id");
			var minutes_id = $textarea.attr("id");

			var target =  $textarea.attr("judge_minutes");
			this.$emit('domergetag', target, agenda_detail_id, minutes_id, $tagid, $text, false);
		},
		
		escapeSelectorString(val){
			if(!isNaN(val)){
				return val;
			} else {
				return val.replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, "\\$&");
			}
		},
		
		getObjectID() {
			var S="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
			var N=31;
			return "O" + Array.from(crypto.getRandomValues(new Uint8Array(N))).map((n)=>S[n%S.length]).join('');
		},
		
		tagSave() {
			var $modal = $("#minutes-tag-modal");
			var $text = $modal.find('[name="minutes_tagname"]').val();
			if($text == "" || $text == null) {
				$modal.find('[name="invalid-feedback"]').text("入力してください");
				$modal.find('[name="minutes_tagname"]').addClass("is-invalid");
				$modal.find('[name="minutes_tagname"]').focus();
			} else {
				var $tagarea = $("[active-modal-icon]");
				var $taskarearight = $(".minutes-active").closest("tr").find(".table-tag-area .additional-info-tag");
				if ( $taskarearight.find('i[title="' + this.escapeSelectorString($text)+'"]').length) {
					$modal.find('[name="invalid-feedback"]').text("同じタグが登録されています");
					$modal.find('[name="minutes_tagname"]').addClass("is-invalid");
					$modal.find('[name="minutes_tagname"]').focus();
				} else if ( $text.trim() == "決定" || $text.trim() == "重要") {
					$modal.find('[name="invalid-feedback"]').text("固定タグは自由タグとして登録できません");
					$modal.find('[name="minutes_tagname"]').addClass("is-invalid");
					$modal.find('[name="minutes_tagname"]').focus();
				} else {
					this.appendTags($tagarea, $text);
					$modal.find('.tag_history').find('[value="' + this.escapeSelectorString($text) + '"]').remove();;
					$modal.find('.tag_history').prepend($("<span></span>").attr("value", $text).text($text));
					$("#minutes-tag-modal").modal("hide");
				}
			}
		},
		
		eventStop(e) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
		},
		
		nullToEmpty(str) {
			return (str == null) ? "" : str;
		},
		
		makeSelect2(element, value, width, placeholder, allowClearFlag, setValueFlag, tagFlag, optionLength, event) {
			$(element).addClass("select2-clear-flag");
			if ($(element).hasClass("presenter_detail")) {
				const $attendlist = $(".PersonList .PersonBlock");
				var tempid = $(element).val();
				$(element).empty();
				$.each($attendlist, function(i, personblock) {
					var userid = $(personblock).attr("user_id");
					var username = $(personblock).attr("user_name")
					var $op = $('<option></option>').val(userid).text("[" + userid + "] " + username );

					$(element).append($op.clone(false));
					if (event != null) {
						if (!$(event.target).hasClass("btn") && tempid != "" && userid == tempid) {
							var value = tempid;
						} else if ($(event.target).closest(".agenda_row").length || $(event.target).closest(".agenda-main-box").length) {
							var value = "";
						}
					}  
				})
				const $guestattendlist = $(".GuestPersonList .GuestPersonBlock");
				$.each($guestattendlist, function(i, guestpersonblock) {
					var userid = $(guestpersonblock).attr("user_id");
					var username = $(guestpersonblock).find(".GuestPerson").text();
					var $op = $('<option></option>').val(userid).text(username);
					$(element).append($op.clone(false));
				})
			} 
			var setplaceholder = "";
			if (placeholder != "") {
				setplaceholder = placeholder+"を選択";
			}
			
			$(element).select2({
				dropdownAutoWidth: false,
				width: width,
				placeholder: setplaceholder,
				allowClear: allowClearFlag,
				dropdownParent: $(element).parent(),
				language: 'ja',
				tags: tagFlag,
				minimumResultsForSearch: optionLength
			})

			if (setValueFlag) {
				$(element).val(value).trigger('change');
			}  

			$(".select2-clear-flag").on('select2:clear', function (e) {
				$(".select2-clear-flag").select2("close");
			});
		},
	},
	
	mounted() {
		const _self = this;
		
		$("#minutes-tag-modal").on("hidden.bs.modal", function(e) {
			$(this).find('form').trigger('reset');
			const $tag = $("[active-modal-icon]");
			$tag.removeAttr("active-modal-icon");
			$(".minutes-active").closest(".minutes_manager_area").find(".minutes_manager").focus();
		});
		
		$("#minutes-tag-modal button[name='minutes-btn-delete']").on("click", function(e) {
			const $tagid = $(".minutes-ul .tag-area p[active-modal-icon]").attr("tagid");
			$(".minutes-ul .tag-area p[active-modal-icon]").remove();
			const $tag = $(".minutes-active").closest(".minutes_manager_area").find(".additional-info-tag");
			$tag.find('[tagid="'+_self.escapeSelectorString($tagid)+'"]').remove();
			this.$emit('@createrighttag-emit');
			$("#minutes-tag-modal").modal("hide");
		});
		
		$("#minutes-tag-modal button[name='minutes-btn-delete']").on("click", function(e) {
			$tagid = $(".minutes-ul .tag-area p[active-modal-icon]").attr("tagid");
			$(".minutes-ul .tag-area p[active-modal-icon]").remove();
			$tag = $(".minutes-active").closest(".minutes_manager_area").find(".additional-info-tag");
			$tag.find('[tagid="'+escapeSelectorString($tagid)+'"]').remove();
			createRightTag();
			$("#minutes-tag-modal").modal("hide");
		});

		$("#minutes-tag-modal").on("show.bs.modal", function(e) {
			
			if (_self.isFirst) {
				$.each(_self.sendTag,function(i,elem){
					if (elem["FREE_TAG_FLAG"] == "1") {
						var $op = $('<span></span>').attr("value", elem["TAG_NAME"]).text(elem["TAG_NAME"]);
						$("#minutes_tagname_list").append($op);
					}
				});
				_self.isFirst = false;
			}


			$(this).find('.is-invalid').removeClass("is-invalid");
			const $modal = $("#minutes-tag-modal");
			$modal.find('[name="minutes_tagname"] option').remove();
			const $tagid = $("[active-modal-icon]");
			$("[active-modal-icon]").removeClass("active-modal-icon")
			var $val = "";
			if($tagid.length) {
				$val = $tagid.find("span").text();
			}
			var attendlist = $("#minutes_tagname_list span");
			var historylist = [];

			$.each( $modal.find('.tag_history span') ,function(i,elem) {
				historylist.push( {value:$(elem).attr("value") });
				if($val == $(elem).text()) {
					$modal.find('[name="minutes_tagname"]').append($("<option selected></option>").val($(elem).attr("value")).text($(elem).text()));
				} else {
					$modal.find('[name="minutes_tagname"]').append($("<option></option>").val($(elem).attr("value")).text($(elem).text()));
				}
			});

			$.each(attendlist,function(i,elem) {
				var taguserobj =  historylist.find((v) => v.value === _self.escapeSelectorString($(elem).attr("value")));
				if(taguserobj != undefined) {
					return;
				}
				if($val == $(elem).attr("value")) {
					$modal.find('[name="minutes_tagname"]').append($("<option selected></option>").val($(elem).attr("value")).text($(elem).text()));
				} else {
					$modal.find('[name="minutes_tagname"]').append($("<option></option>").val($(elem).attr("value")).text($(elem).text()));
				}
			});
			_self.makeSelect2($modal.find('[name="minutes_tagname"]'), "", "100%", "タグ", true, false, true, 0);
			const $li = _self.nullToEmpty($modal.find('[name="minutes_tagname"]').val());
			if($li.length) {
				$modal.find("button[name='minutes-btn-delete']").css("display", "block");
			} else {
				$modal.find("button[name='minutes-btn-delete']").css("display", "none");
			}
		});
		
		$("#minutes-tag-modal").on("shown.bs.modal", function(e) {
			
			const $modal = $("#minutes-tag-modal");
			$modal.find('[name="dummytext"]').css("visibility", "visible");
			$modal.find('[name="dummytext"]').focus();
			$modal.find('[name="dummytext"]').css("visibility", "hidden");

			setTimeout(function(){ 
				$modal.find('[name="minutes_tagname"]').select2("open");
				document.querySelector('.select2-search__field').focus(); 
			},50);
		});
		
		$("#minutes-tag-modal").on("keydown", function(e) {
			if (e.keyCode == 13) {
				var $focus = $(':focus');
			if($focus.length && $focus.closest("div").hasClass("minutes_tag_parent")) {
				_self.tagSave();
			}
			_self.eventStop(e);
			}
		});
		
		$("#minutes-tag-modal [name='minutes_tagname']").on('select2:closing', function() {
			var flag = true;
			var newval = $(this).closest("form").find(".select2-search__field").val();
			var elem = this;

			$.each($(this).find("option"), function(i, option) {
				if ($(option).text() == newval && $(option).attr("data-select2-tag") == "true") {
					flag = false;
					return false;
				} else if ($(option).text() == newval) {
					$(elem).val($(option).val()).trigger('change')
					return false;
				}
			})
			if(!flag) {
				$(this).append($("<option selected></option>").val(newval).text(newval));
			}
		});
		
		$("#minutes-tag-modal [name='minutes_tagname']").on('select2:select', function (e) {
			var $focus = $(':focus');
			if($focus.length && $focus.closest("div").hasClass("minutes_tag_parent")) {
				_self.tagSave();
			}
			_self.eventStop(e);
		});
	}
}
</script>
<style>
.tag-btn-area {
	display: flex;
	justify-content: end;
}

.tag-modal-size {
	width: 350px !important;
}

.tag-btn-area button {
	font-size: 12px;
	height: fit-content;
}
</style>